import { Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { GuestGuard } from './guards/guest.guard';

export const routes: Routes = [
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  {
    path: 'login',
    loadComponent: () => import('./pages/auth/login/login.component').then(m => m.LoginComponent),
    canActivate: [GuestGuard]
  },
  {
    path: 'word-expert',
    loadComponent: () => import('./pages/auth/word-expert/word-expert.component').then(m => m.WordExpertComponent),
    canActivate: [GuestGuard]
  },
  {
    path: 'wachtwoord-vergeten',
    loadComponent: () => import('./pages/auth/wachtwoord-vergeten/wachtwoord-vergeten.component').then(m => m.WachtwoordVergetenComponent),
    canActivate: [GuestGuard]
  },
  {
    path: 'wachtwoord-wijzigen',
    loadComponent: () => import('./pages/auth/wachtwoord-wijzigen/wachtwoord-wijzigen.component').then(m => m.WachtwoordWijzigenComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'bedrijf-selecteren',
    loadComponent: () => import('./pages/auth/bedrijf-selecteren/bedrijf-selecteren.component').then(m => m.BedrijfSelecterenComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./pages/dashboard/dashboard.component').then(m => m.DashboardComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'bieden',
    loadComponent: () => import('./pages/bieden/bieden.component').then(m => m.BiedenComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'bieden/geboden',
    loadComponent: () => import('./pages/bieden/bieden.component').then(m => m.BiedenComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'bieden/niet-geboden',
    loadComponent: () => import('./pages/bieden/bieden.component').then(m => m.BiedenComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'geboden',
    loadComponent: () => import('./pages/eerder/eerder.component').then(m => m.EerderComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'geboden/hoogste-bod',
    loadComponent: () => import('./pages/eerder/eerder.component').then(m => m.EerderComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'geboden/wel-geboden',
    loadComponent: () => import('./pages/eerder/eerder.component').then(m => m.EerderComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'geboden/niet-geboden',
    loadComponent: () => import('./pages/eerder/eerder.component').then(m => m.EerderComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'favorieten',
    loadComponent: () => import('./pages/favorieten/favorieten.component').then(m => m.FavorietenComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'aanbevolen',
    loadComponent: () => import('./pages/aanbevolen/aanbevolen.component').then(m => m.AanbevolenComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'mijn-voertuigen',
    loadComponent: () => import('./pages/mijn-voertuigen/mijn-voertuigen.component').then(m => m.MijnVoertuigenComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'mijn-voertuigen/te-verwachten',
    loadComponent: () => import('./pages/mijn-voertuigen/mijn-voertuigen.component').then(m => m.MijnVoertuigenComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'mijn-voertuigen/afgeleverd',
    loadComponent: () => import('./pages/mijn-voertuigen/mijn-voertuigen.component').then(m => m.MijnVoertuigenComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'verkocht',
    loadComponent: () => import('./pages/verkocht/verkocht.component').then(m => m.VerkochtComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'zoeken',
    loadComponent: () => import('./pages/zoeken/zoeken.component').then(m => m.ZoekenComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'statistieken',
    loadComponent: () => import('./pages/statistieken/statistieken.component').then(m => m.StatistiekenComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'instellingen',
    loadComponent: () => import('./pages/instellingen/instellingen.component').then(m => m.InstellingenComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'notificaties',
    loadComponent: () => import('./pages/notificaties/notificaties.component').then(m => m.NotificatiesComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'taxatie/:id',
    loadComponent: () => import('./pages/taxatie-detail/taxatie-detail.component').then(m => m.TaxatieDetailComponent),
    outlet: 'modal',
    canActivate: [AuthGuard]
  },
  {
    path: 'niet-gevonden',
    loadComponent: () => import('./pages/utilities/niet-gevonden/niet-gevonden.component').then(m => m.NotFoundComponent)
  },
  { path: '**', redirectTo: '/niet-gevonden' },
];
